module.exports = __webpack_public_path__ + "img/21.4.NH3-N.a8e2d099.png";